export default "__VITE_ASSET__KZgOQ$fH__"